import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertDialog, DialogEntity } from '@lyearn/molecules';
import { Stack, Typography } from '@lyearn/ui';
import LexicalEditor from '@/components/LexicalEditor';
import * as MessageItem from '@/components/MessageItem';

import { DeleteCommentDialogProps } from './types';

function DeleteCommentDialog(props: DeleteCommentDialogProps) {
  const { title, description, onClose, onDelete, message } = props;
  const { t } = useTranslation();

  if (!message) return null;

  return (
    <AlertDialog
      header={{
        title: title,
        description: description,
      }}
      primaryAction={{
        label: t('Common:Actions.Delete'),
        onClick: onDelete,
        appearance: 'danger',
      }}
      onClose={onClose}>
      <MessageItem.Provider className="flex flex-col space-y-8" message={message}>
        <DialogEntity
          descriptionNode={
            <Stack className="max-h-[200px] overflow-hidden">
              <LexicalEditor
                classes={{ mediaPlugin: 'hidden' }}
                disableEditor={true}
                value={message.message}
              />
            </Stack>
          }
          title={
            <Stack alignItems="center">
              <MessageItem.CreatedBy color="text-text-primary" variant="heading-xxs" />
              <Typography color="text-text-placeholder" variant="body-short-03">
                &nbsp;•&nbsp;
              </Typography>
              <MessageItem.Timestamp />
            </Stack>
          }
        />
      </MessageItem.Provider>
    </AlertDialog>
  );
}

export default DeleteCommentDialog;
